module.exports = __webpack_public_path__ + "assets/img/status-default.a830ca2e.svg";